import type { ExpenseBreakdownEntity } from "../entities/ExpenseBreakdownEntity";
import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";

export class GetExpenseBreakdownUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(
    type: "vendor" | "category",
    timeframe: "ytd" | "last_month",
  ): Promise<ExpenseBreakdownEntity> {
    return this.repository.getExpenseBreakdown(type, timeframe);
  }
}
